import { StyleSheet } from 'react-native';

import { mediaQueryValues } from '../media-query';
import {
  button,
  extraSmallMarginBottomBox,
  extraSmallPaddingHorizontalOptionButton,
} from '../view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    ...extraSmallMarginBottomBox,
  },
  button: {
    flexDirection: 'row',
    ...button,
  },
  image: {
    height: mediaQuery.extraSmallImage,
    width: mediaQuery.smallImage,
    borderRadius: 4,
    marginHorizontal: -mediaQuery.extraSmall,
  },
  optionKeyContainer: {
    alignSelf: 'center',
    ...button,
    paddingVertical: 2,
    ...extraSmallPaddingHorizontalOptionButton,
    marginLeft: -15,
    marginBottom: 2,
  },
  text: {
    textAlign: 'center',
  },
  audioIcon: {
    marginRight: 15,
  },
});
